import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const DiscountChipWrapper = styled.div`
  border-radius: 8px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  height: 22px;
  color: ${myPalette.black.main};
  background: ${myPalette.blue.primaryLight};
  border: none;
  position: absolute;
  right: 12px;
  bottom: 12px;
`

export const DiscountChipText = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${myPalette.midnightBlue.primary};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const OldPrice = styled.div`
  color: ${myPalette.mutedText.main};
  text-decoration: line-through;
`
